export const isValidDate = (value: string | Date) => !isNaN(Date.parse(String(new Date(value))));
